// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-area {
  direction: rtl;
  text-align: right;
}

h1 {
  font-size: 20px;
}

.button2-style {
  background-color: aliceblue;
  font-size: 12px;
  width: 100px;
  margin-left: 25px;
}

.text {
  direction: rtl;
  text-align: right;
}

.provider-title {
  font-size: 13px;
}

.title {
  margin-bottom: -22px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-card div textarea.text-area {
  direction: rtl;
  text-align: right;
  height: 180px;
}

::ng-deep .mat-form-field-wrapper.ng-tns-c81-9 {
  direction: rtl;
  text-align: right;
}

.mat-form-field-wrapper.ng-tns-c81-59 {
  direction: rtl;
  text-align: right;
}

.btns {
  margin-top: 2rem;
}

button {
  width: 10rem;
  font-size: 12px;
  margin-right: 10px;
}

img {
  max-width: 12rem;
  max-height: 12rem;
}

.document {
  display: flex;
  direction: rtl;
  overflow: auto;
}

.items {
  display: flex;
  direction: rtl;
  margin-right: 2rem;
  margin-top: 2rem;
}

.label-title {
  font-size: small;
}

mat-card {
  margin-top: 2rem;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.38), 0px 1px 1px 0px rgba(0, 0, 0, 0.22), 0px 1px 3px 0px rgba(0, 0, 0, 0.24);
  padding: 20px;
}

.amount-title {
  display: flex;
  margin-top: 2rem;
}

.amount-style {
  margin-right: 1rem;
}

.file-input {
  display: none;
}

.file-upload.upload {
  text-align: center;
}

.upload-style {
  margin-top: 3rem;
}

.upload-btn {
  border-radius: 10px;
}

mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color.ng-star-inserted {
  font-size: 18px;
  color: green;
  margin: auto;
}

.file-name {
  font-size: small;
}

button.mat-focus-indicator.button-contract.mat-button.mat-button-base {
  background-color: #d5e3ef;
  margin-top: 2rem;
  border-radius: 14px;
  text-align: center;
}

button {
  margin-top: 20px;
  height: 3rem;
  background-color: #cfcfe7;
  text-align: end;
}

.text-download {
  text-align: center;
  font-size: 13px;
  color: #3e6b6c;
}

.title-contract {
  text-align: end;
}

.card-img {
  width: 100%;
  height: 82%;
}

.image-text {
  text-align: center;
}

button.mat-focus-indicator.accept-contract.mat-button.mat-button-base {
  background-color: #2dd36f;
}

button.mat-focus-indicator.reject-contract.mat-button.mat-button-base {
  background-color: #eb445a;
}

.no-document {
  text-align: end;
  margin: auto;
  margin-top: 2rem;
  font-size: small;
}

.btn_back {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
}

.btn_contract {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  background-color: #2a8954 !important;
  color: white !important;
}

.btn-accept_contract {
  border-radius: 15px;
  height: 40px;
  font-size: 12px;
  width: 88px;
  background-color: #2a8954 !important;
  color: white !important;
}

.btn-reject_contract {
  border-radius: 15px;
  height: 40px;
  font-size: 12px;
  width: 88px;
  background-color: #d92727 !important;
  color: white !important;
}

.btn-accept {
  border-radius: 15px;
  height: 45px;
  font-size: 12px;
  width: 120px;
  background-color: #2a8954 !important;
  color: white !important;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

ngx-editor {
  direction: rtl;
  height: 20rem !important;
}

.parent-file {
  display: flex;
}

.icon-btn {
  width: 10px;
}

.parent-span {
  display: flex;
}

.NgxEditor__Wrapper {
  height: 20rem;
  overflow-y: scroll;
  margin-top: 20px;
}

.parent-customer {
  display: flex;
  direction: rtl;
}

.text-customer {
  margin-top: 25px;
  font-size: small;
}

.parent-all {
  display: flex;
  justify-content: space-around;
}

.parent-provider {
  display: flex;
  direction: rtl;
}`, "",{"version":3,"sources":["webpack://./src/app/features/contracts/contracts-text/contracts-text.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/contracts/contracts-text/contracts-text.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,iBAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,2BAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;ACCF;;ADEA;EACE,cAAA;EACA,iBAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCF;;ADII;EACE,cAAA;EACA,iBAAA;EACA,aAAA;ACDN;;ADMA;EACE,cAAA;EACA,iBAAA;ACHF;;ADMA;EACE,cAAA;EACA,iBAAA;ACHF;;ADMA;EACE,gBAAA;ACHF;;ADMA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;ACHF;;ADMA;EACE,gBAAA;EACA,iBAAA;ACHF;;ADMA;EACE,aAAA;EACA,cAAA;EACA,cAAA;ACHF;;ADMA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;ACHF;;ADMA;EACE,gBAAA;ACHF;;ADMA;EACE,gBAAA;EACA,0HAAA;EACA,aAAA;ACHF;;ADMA;EACE,aAAA;EACA,gBAAA;ACHF;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,aAAA;ACHF;;ADMA;EACE,kBAAA;ACHF;;ADMA;EACE,gBAAA;ACHF;;ADMA;EACE,mBAAA;ACHF;;ADMA;EACE,eAAA;EACA,YAAA;EACA,YAAA;ACHF;;ADMA;EACE,gBAAA;ACHF;;ADMA;EACE,yBAAA;EACA,gBAAA;EAGA,mBAAA;EACA,kBAAA;ACLF;;ADSA;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;ACNF;;ADSA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;ACNF;;ADSA;EACE,eAAA;ACNF;;ADSA;EACE,WAAA;EACA,WAAA;ACNF;;ADSA;EACE,kBAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ACNF;;ADaA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;ACVF;;ADaA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;ACVF;;ADaA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,uBAAA;ACVF;;ADaA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,uBAAA;ACVF;;ADaA;EACE,mBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,uBAAA;ACVF;;ADaA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACVF;;ADaA;EACE,cAAA;EACA,wBAAA;ACVF;;ADaA;EACE,aAAA;ACVF;;ADaA;EACE,WAAA;ACVF;;ADaA;EACE,aAAA;ACVF;;ADYA;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;ACTF;;ADWA;EACE,aAAA;EACA,cAAA;ACRF;;ADUA;EACE,gBAAA;EACA,gBAAA;ACPF;;ADSA;EACE,aAAA;EACA,6BAAA;ACNF;;ADQA;EACE,aAAA;EACA,cAAA;ACLF","sourcesContent":[".txt-area {\r\n  direction: rtl;\r\n  text-align: right;\r\n}\r\n\r\nh1 {\r\n  font-size: 20px;\r\n}\r\n\r\n.button2-style {\r\n  background-color: aliceblue;\r\n  font-size: 12px;\r\n  width: 100px;\r\n  margin-left: 25px;\r\n}\r\n\r\n.text {\r\n  direction: rtl;\r\n  text-align: right;\r\n}\r\n\r\n.provider-title {\r\n  font-size: 13px;\r\n}\r\n\r\n.title {\r\n  margin-bottom: -22px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\nmat-card {\r\n  div {\r\n    textarea.text-area {\r\n      direction: rtl;\r\n      text-align: right;\r\n      height: 180px;\r\n    }\r\n  }\r\n}\r\n\r\n::ng-deep .mat-form-field-wrapper.ng-tns-c81-9 {\r\n  direction: rtl;\r\n  text-align: right;\r\n}\r\n\r\n.mat-form-field-wrapper.ng-tns-c81-59 {\r\n  direction: rtl;\r\n  text-align: right;\r\n}\r\n\r\n.btns {\r\n  margin-top: 2rem;\r\n}\r\n\r\nbutton {\r\n  width: 10rem;\r\n  font-size: 12px;\r\n  margin-right: 10px;\r\n}\r\n\r\nimg {\r\n  max-width: 12rem;\r\n  max-height: 12rem;\r\n}\r\n\r\n.document {\r\n  display: flex;\r\n  direction: rtl;\r\n  overflow: auto;\r\n}\r\n\r\n.items {\r\n  display: flex;\r\n  direction: rtl;\r\n  margin-right: 2rem;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.label-title {\r\n  font-size: small;\r\n}\r\n\r\nmat-card {\r\n  margin-top: 2rem;\r\n  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 38%), 0px 1px 1px 0px rgb(0 0 0 / 22%), 0px 1px 3px 0px rgb(0 0 0 / 24%);\r\n  padding: 20px;\r\n}\r\n\r\n.amount-title {\r\n  display: flex;\r\n  margin-top: 2rem;\r\n}\r\n\r\n.amount-style {\r\n  margin-right: 1rem;\r\n}\r\n\r\n.file-input {\r\n  display: none;\r\n}\r\n\r\n.file-upload.upload {\r\n  text-align: center;\r\n}\r\n\r\n.upload-style {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.upload-btn {\r\n  border-radius: 10px;\r\n}\r\n\r\nmat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color.ng-star-inserted {\r\n  font-size: 18px;\r\n  color: green;\r\n  margin: auto;\r\n}\r\n\r\n.file-name {\r\n  font-size: small;\r\n}\r\n\r\nbutton.mat-focus-indicator.button-contract.mat-button.mat-button-base {\r\n  background-color: #d5e3ef;\r\n  margin-top: 2rem;\r\n  // width: 12rem;\r\n  // height: 3rem;\r\n  border-radius: 14px;\r\n  text-align: center;\r\n\r\n}\r\n\r\nbutton {\r\n  margin-top: 20px;\r\n  height: 3rem;\r\n  background-color: #cfcfe7;\r\n  text-align: end;\r\n}\r\n\r\n.text-download {\r\n  text-align: center;\r\n  font-size: 13px;\r\n  color: #3e6b6c;\r\n}\r\n\r\n.title-contract {\r\n  text-align: end;\r\n}\r\n\r\n.card-img {\r\n  width: 100%;\r\n  height: 82%;\r\n}\r\n\r\n.image-text {\r\n  text-align: center;\r\n}\r\n\r\nbutton.mat-focus-indicator.accept-contract.mat-button.mat-button-base {\r\n  background-color: #2dd36f;\r\n}\r\n\r\nbutton.mat-focus-indicator.reject-contract.mat-button.mat-button-base {\r\n  background-color: #eb445a;\r\n}\r\n\r\n.no-document {\r\n  text-align: end;\r\n  margin: auto;\r\n  margin-top: 2rem;\r\n  font-size: small;\r\n}\r\n\r\n// span.ng-star-inserted{\r\n//   display: flex;\r\n//   direction: rtl;\r\n// }\r\n.btn_back {\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 120px;\r\n}\r\n\r\n.btn_contract {\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 120px;\r\n  background-color: #2a8954 !important;\r\n  color: white !important;\r\n}\r\n\r\n.btn-accept_contract {\r\n  border-radius: 15px;\r\n  height: 40px;\r\n  font-size: 12px;\r\n  width: 88px;\r\n  background-color: #2a8954 !important;\r\n  color: white !important;\r\n}\r\n\r\n.btn-reject_contract {\r\n  border-radius: 15px;\r\n  height: 40px;\r\n  font-size: 12px;\r\n  width: 88px;\r\n  background-color: #d92727 !important;\r\n  color: white !important;\r\n}\r\n\r\n.btn-accept {\r\n  border-radius: 15px;\r\n  height: 45px;\r\n  font-size: 12px;\r\n  width: 120px;\r\n  background-color: #2a8954 !important;\r\n  color: white !important;\r\n}\r\n\r\n.parent-both {\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}\r\n\r\nngx-editor {\r\n  direction: rtl;\r\n  height: 20rem !important;\r\n}\r\n\r\n.parent-file {\r\n  display: flex;\r\n}\r\n\r\n.icon-btn {\r\n  width: 10px;\r\n}\r\n\r\n.parent-span {\r\n  display: flex;\r\n}\r\n.NgxEditor__Wrapper {\r\n  height: 20rem;\r\n  overflow-y: scroll;\r\n  margin-top: 20px;\r\n}\r\n.parent-customer{\r\n  display: flex;\r\n  direction: rtl;\r\n}\r\n.text-customer {\r\n  margin-top: 25px;\r\n  font-size: small;\r\n}\r\n.parent-all{\r\n  display: flex;\r\n  justify-content: space-around;\r\n}\r\n.parent-provider{\r\n  display: flex;\r\n  direction: rtl;\r\n}",".txt-area {\n  direction: rtl;\n  text-align: right;\n}\n\nh1 {\n  font-size: 20px;\n}\n\n.button2-style {\n  background-color: aliceblue;\n  font-size: 12px;\n  width: 100px;\n  margin-left: 25px;\n}\n\n.text {\n  direction: rtl;\n  text-align: right;\n}\n\n.provider-title {\n  font-size: 13px;\n}\n\n.title {\n  margin-bottom: -22px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-card div textarea.text-area {\n  direction: rtl;\n  text-align: right;\n  height: 180px;\n}\n\n::ng-deep .mat-form-field-wrapper.ng-tns-c81-9 {\n  direction: rtl;\n  text-align: right;\n}\n\n.mat-form-field-wrapper.ng-tns-c81-59 {\n  direction: rtl;\n  text-align: right;\n}\n\n.btns {\n  margin-top: 2rem;\n}\n\nbutton {\n  width: 10rem;\n  font-size: 12px;\n  margin-right: 10px;\n}\n\nimg {\n  max-width: 12rem;\n  max-height: 12rem;\n}\n\n.document {\n  display: flex;\n  direction: rtl;\n  overflow: auto;\n}\n\n.items {\n  display: flex;\n  direction: rtl;\n  margin-right: 2rem;\n  margin-top: 2rem;\n}\n\n.label-title {\n  font-size: small;\n}\n\nmat-card {\n  margin-top: 2rem;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.38), 0px 1px 1px 0px rgba(0, 0, 0, 0.22), 0px 1px 3px 0px rgba(0, 0, 0, 0.24);\n  padding: 20px;\n}\n\n.amount-title {\n  display: flex;\n  margin-top: 2rem;\n}\n\n.amount-style {\n  margin-right: 1rem;\n}\n\n.file-input {\n  display: none;\n}\n\n.file-upload.upload {\n  text-align: center;\n}\n\n.upload-style {\n  margin-top: 3rem;\n}\n\n.upload-btn {\n  border-radius: 10px;\n}\n\nmat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color.ng-star-inserted {\n  font-size: 18px;\n  color: green;\n  margin: auto;\n}\n\n.file-name {\n  font-size: small;\n}\n\nbutton.mat-focus-indicator.button-contract.mat-button.mat-button-base {\n  background-color: #d5e3ef;\n  margin-top: 2rem;\n  border-radius: 14px;\n  text-align: center;\n}\n\nbutton {\n  margin-top: 20px;\n  height: 3rem;\n  background-color: #cfcfe7;\n  text-align: end;\n}\n\n.text-download {\n  text-align: center;\n  font-size: 13px;\n  color: #3e6b6c;\n}\n\n.title-contract {\n  text-align: end;\n}\n\n.card-img {\n  width: 100%;\n  height: 82%;\n}\n\n.image-text {\n  text-align: center;\n}\n\nbutton.mat-focus-indicator.accept-contract.mat-button.mat-button-base {\n  background-color: #2dd36f;\n}\n\nbutton.mat-focus-indicator.reject-contract.mat-button.mat-button-base {\n  background-color: #eb445a;\n}\n\n.no-document {\n  text-align: end;\n  margin: auto;\n  margin-top: 2rem;\n  font-size: small;\n}\n\n.btn_back {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n}\n\n.btn_contract {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  background-color: #2a8954 !important;\n  color: white !important;\n}\n\n.btn-accept_contract {\n  border-radius: 15px;\n  height: 40px;\n  font-size: 12px;\n  width: 88px;\n  background-color: #2a8954 !important;\n  color: white !important;\n}\n\n.btn-reject_contract {\n  border-radius: 15px;\n  height: 40px;\n  font-size: 12px;\n  width: 88px;\n  background-color: #d92727 !important;\n  color: white !important;\n}\n\n.btn-accept {\n  border-radius: 15px;\n  height: 45px;\n  font-size: 12px;\n  width: 120px;\n  background-color: #2a8954 !important;\n  color: white !important;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\nngx-editor {\n  direction: rtl;\n  height: 20rem !important;\n}\n\n.parent-file {\n  display: flex;\n}\n\n.icon-btn {\n  width: 10px;\n}\n\n.parent-span {\n  display: flex;\n}\n\n.NgxEditor__Wrapper {\n  height: 20rem;\n  overflow-y: scroll;\n  margin-top: 20px;\n}\n\n.parent-customer {\n  display: flex;\n  direction: rtl;\n}\n\n.text-customer {\n  margin-top: 25px;\n  font-size: small;\n}\n\n.parent-all {\n  display: flex;\n  justify-content: space-around;\n}\n\n.parent-provider {\n  display: flex;\n  direction: rtl;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
